const initialState = {
    //list unused quotation
    loadingUnusedQuotationList: false,
    UnusedQuotationListError: "",
    UnusedQuotationList: [],

    loadingUnusedQuotationByCompanyList: false,
    UnusedQuotationByCompanyListError: "",
    UnusedQuotationByCompanyList: [],

    //list job order
    loadingJobOrderList: false,
    JobOrderListError: "",
    JobOrderList: [],
    JobOrderListCurrentPage: 0,
    JobOrderListTotalPage: 0,
    JobOrderListTotalData: 0,

    //list job order employee
    loadingJobOrderEmployeeList: false,
    JobOrderEmployeeListError: "",
    JobOrderEmployeeList: [],

    //detail job order 
    loadingJobOrderDetail: false,
    JobOrderDetailError: "",
    JobOrderDetail: [],

    //detail job order service
    loadingJobOrderServiceDetail: false,
    JobOrderServiceDetailError: "",
    JobOrderServiceDetail: [],

    //list job order customer
    loadingJobOrderCustomerList: false,
    JobOrderCustomerListError: "",
    JobOrderCustomerList: [],

    //detail job order service
    loadingJobOrderEntityDetail: false,
    JobOrderEntityDetailError: "",
    JobOrderEntityDetail: [],

    //detail job order customs
    loadingJobOrderCustomsDetail: false,
    JobOrderCustomsDetailError: "",
    JobOrderCustomsDetail: [],

    //list job order custom house
    loadingJobOrderCustomsHouseList: false,
    JobOrderCustomsHouseListError: "",
    JobOrderCustomsHouseList: [],

    //list job order exim scheme
    loadingJobOrderEximSchemeList: true,
    JobOrderEximSchemeList: [],
    JobOrderEximSchemeListError: "",

    //list job order airline
    loadingJobOrderAirlineList: true,
    JobOrderAirlineList: [],
    JobOrderAirlineListError: "",

    //list job order shipline
    loadingJobOrderShiplineList: true,
    JobOrderShiplineList: [],
    JobOrderShiplineListError: "",

    //list job order port
    loadingJobOrderPortList: true,
    JobOrderPortList: [],
    JobOrderPortListError: "",

    //list job order airport
    loadingJobOrderAirportList: true,
    JobOrderAirportList: [],
    JobOrderAirportListError: "",

    //list job order sea
    loadingJobOrderSeaportList: true,
    JobOrderSeaportList: [],
    JobOrderSeaportListError: "",

    //detail job order customs
    loadingJobOrderFreightDetail: false,
    JobOrderFreightDetailError: "",
    JobOrderFreightDetail: [],


    //list job order incoterms
    loadingJobOrderIncotermList: false,
    JobOrderIncotermListError: "",
    JobOrderIncotermList: [],

    //list job order currency
    loadingJobOrderCurrencyList: false,
    JobOrderCurrencyListError: "",
    JobOrderCurrencyList: [],

    //list job order cfs
    loadingJobOrderCFSList: false,
    JobOrderCFSListError: "",
    JobOrderCFSList: [],

    //list job order transport pickup branch
    loadingJobOrderTransportPickupBranchList: false,
    JobOrderTransportPickupBranchListError: "",
    JobOrderTransportPickupBranchList: [],

    //list job order transport deliver branch
    loadingJobOrderTransportDeliverBranchList: false,
    JobOrderTransportDeliverBranchListError: "",
    JobOrderTransportDeliverBranchList: [],

    //list job order transport transporter branch
    loadingJobOrderTransportTransporterBranchList: false,
    JobOrderTransportTransporterBranchListError: '',
    JobOrderTransportTransporterBranchList: [],

    //list job order transport list
    loadingJobOrderTransportList: false,
    JobOrderTransportListError: '',
    JobOrderTransportList: [],

    //list job order transport detail
    loadingJobOrderTransportDetail: false,
    JobOrderTransportDetailError: '',
    JobOrderTransportDetail: [],


    //list job order commodity
    loadingJobOrderCommodityList: false,
    JobOrderCommodityListError: '',
    JobOrderCommodityList: [],


    //detail job order cargo dtls
    loadingJobOrderCargoDetail: false,
    JobOrderCargoDetail: [],
    JobOrderCargoDetailError: '',

    //detail job order 
    loadingJobOrderApprovedCustomerList: false,
    JobOrderApprovedCustomerList: [],
    JobOrderApprovedCustomerListError: '',

    loadingJobOrderCompanyBranchList: true,
    JobOrderCompanyBranchList: [],
    JobOrderCompanyBranchListError: '',


    //quotation list with pagiantion.
    //ff-> air-> exp -> direct shipment list
    loadingUnusedFinalQuotationWithPaginationList: false,
    UnusedFinalQuotationWithPaginationList: [],
    UnusedFinalQuotationWithPaginationListError: '',
    UnusedFinalQuotationWithPaginationListCurrentPage: 0,
    UnusedFinalQuotationWithPaginationListTotalPage: 0,
    UnusedFinalQuotationWithPaginationListTotalData: 0,



    //job order ff details
    loadingJobOrderFFDetails: true,
    JobOrderFFDetails: null,
    JobOrderFFDetailsError: '',

}

const JoborderReducer = (state = initialState, action) => {
    switch (action.type) {

        //list unused quotation with pagination//
        case 'FIND_UNUSED_FINAL_QUOTATION_WITH_PAGINATION_REQUEST':
            return {
                ...state,
                loadingUnusedFinalQuotationWithPaginationList: true,
                UnusedFinalQuotationWithPaginationList: [],
                UnusedFinalQuotationWithPaginationListError: "",
                UnusedFinalQuotationWithPaginationListCurrentPage: 1,
                UnusedFinalQuotationWithPaginationListTotalPage: 1,
                UnusedFinalQuotationWithPaginationListTotalData: 0,
            };
        case 'FIND_UNUSED_FINAL_QUOTATION_WITH_PAGINATION_SUCCESS':
            return {
                ...state,
                loadingUnusedFinalQuotationWithPaginationList: false,
                UnusedFinalQuotationWithPaginationList: action.payload.data,
                UnusedFinalQuotationWithPaginationListError: "",
                UnusedFinalQuotationWithPaginationListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                UnusedFinalQuotationWithPaginationListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
                UnusedFinalQuotationWithPaginationListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_UNUSED_FINAL_QUOTATION_WITH_PAGINATION_FAILURE':
            return {
                ...state,
                loadingUnusedFinalQuotationWithPaginationList: false,
                UnusedFinalQuotationWithPaginationList: [],
                UnusedFinalQuotationWithPaginationListError: action.payload,
                UnusedFinalQuotationWithPaginationListCurrentPage: 1,
                UnusedFinalQuotationWithPaginationListTotalPage: 1,
                UnusedFinalQuotationWithPaginationListTotalData: 0,
            };
        //list unused quotation with Pagination//

        //list unused quotation//
        case 'FIND_UNUSED_QUOTATION_LIST_REQUEST':
            return {
                ...state,
                loadingUnusedQuotationList: true,
                UnusedQuotationList: "",
                UnusedQuotationListError: '',
            };
        case 'FIND_UNUSED_QUOTATION_LIST_SUCCESS':
            return {
                ...state,
                loadingUnusedQuotationList: false,
                UnusedQuotationList: action.payload,
            };
        case 'FIND_UNUSED_QUOTATION_LIST_FAILURE':
            return {
                ...state,
                loadingUnusedQuotationList: false,
                UnusedQuotationListError: action.payload,
            };
        //list unused quotation//

        //list unused quotation by company//
        case 'FIND_UNUSED_QUOTATION_BY_COMPANY_LIST_REQUEST':
            return {
                ...state,
                loadingUnusedQuotationByCompanyList: true,
                UnusedQuotationByCompanyList: "",
                UnusedQuotationByCompanyListError: '',
            };
        case 'FIND_UNUSED_QUOTATION_BY_COMPANY_LIST_SUCCESS':
            return {
                ...state,
                loadingUnusedQuotationByCompanyList: false,
                UnusedQuotationByCompanyList: action.payload,
            };
        case 'FIND_UNUSED_QUOTATION_BY_COMPANY_LIST_FAILURE':
            return {
                ...state,
                loadingUnusedQuotationByCompanyList: false,
                UnusedQuotationByCompanyListError: action.payload,
            };
        //list unused quotation by company//

        //list job order//
        case 'FIND_JOBORDER_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderList: true,
                JobOrderList: [],
                JobOrderListError: '',
                JobOrderListCurrentPage: 0,
                JobOrderListTotalPage: 0,
                JobOrderListTotalData: 0,
            };
        case 'FIND_JOBORDER_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderList: false,
                JobOrderList: action.payload.data,
                JobOrderListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 0,
                JobOrderListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                JobOrderListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_JOBORDER_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderList: false,
                JobOrderListError: action.payload,
                JobOrderListCurrentPage: 0,
                JobOrderListTotalPage: 0,
                JobOrderListTotalData: 0,
            };
        //list job order//

        //list job order employee//
        case 'FIND_JOBORDER_EMPLOYEE_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderEmployeeList: true,
                JobOrderEmployeeList: "",
                JobOrderEmployeeListError: '',
            };
        case 'FIND_JOBORDER_EMPLOYEE_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderEmployeeList: false,
                JobOrderEmployeeList: action.payload,
            };
        case 'FIND_JOBORDER_EMPLOYEE_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderEmployeeList: false,
                JobOrderEmployeeListError: action.payload,
            };
        //list job order employee//

        //detail job order //
        case 'FIND_JOBORDER_DETAIL_REQUEST':
            return {
                ...state,
                loadingJobOrderDetail: true,
                JobOrderDetail: "",
                JobOrderDetailError: '',
            };
        case 'FIND_JOBORDER_DETAIL_SUCCESS':
            return {
                ...state,
                loadingJobOrderDetail: false,
                JobOrderDetail: action.payload,
            };
        case 'FIND_JOBORDER_DETAIL_FAILURE':
            return {
                ...state,
                loadingJobOrderDetail: false,
                JobOrderDetailError: action.payload,
            };
        //detail job order //

        //detail job order service//
        case 'FIND_JOBORDER_SERVICE_DETAIL_REQUEST':
            return {
                ...state,
                loadingJobOrderServiceDetail: true,
                JobOrderServiceDetail: "",
                JobOrderServiceDetailError: '',
            };
        case 'FIND_JOBORDER_SERVICE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingJobOrderServiceDetail: false,
                JobOrderServiceDetail: action.payload,
            };
        case 'FIND_JOBORDER_SERVICE_DETAIL_FAILURE':
            return {
                ...state,
                loadingJobOrderServiceDetail: false,
                JobOrderServiceDetailError: action.payload,
            };
        //detail job order service//

        //list job order customer//
        case 'FIND_JOBORDER_CUSTOMER_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderCustomerList: true,
                JobOrderCustomerList: [],
                JobOrderCustomerListError: '',
            };
        case 'FIND_JOBORDER_CUSTOMER_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderCustomerList: false,
                JobOrderCustomerList: action.payload,
            };
        case 'FIND_JOBORDER_CUSTOMER_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderCustomerList: false,
                JobOrderCustomerListError: action.payload,
            };
        //list job order customer//

        //detail job order entity//
        case 'FIND_JOBORDER_ENTITY_DETAIL_REQUEST':
            return {
                ...state,
                loadingJobOrderEntityDetail: true,
                JobOrderEntityDetail: "",
                JobOrderEntityDetailError: '',
            };
        case 'FIND_JOBORDER_ENTITY_DETAIL_SUCCESS':
            return {
                ...state,
                loadingJobOrderEntityDetail: false,
                JobOrderEntityDetail: action.payload,
            };
        case 'FIND_JOBORDER_ENTITY_DETAIL_FAILURE':
            return {
                ...state,
                loadingJobOrderEntityDetail: false,
                JobOrderEntityDetailError: action.payload,
            };
        //detail job order entity//

        //detail job order customs//
        case 'FIND_JOBORDER_CUSTOMS_DETAIL_REQUEST':
            return {
                ...state,
                loadingJobOrderCustomsDetail: true,
                JobOrderCustomsDetail: "",
                JobOrderCustomsDetailError: '',
            };
        case 'FIND_JOBORDER_CUSTOMS_DETAIL_SUCCESS':
            return {
                ...state,
                loadingJobOrderCustomsDetail: false,
                JobOrderCustomsDetail: action.payload,
            };
        case 'FIND_JOBORDER_CUSTOMS_DETAIL_FAILURE':
            return {
                ...state,
                loadingJobOrderCustomsDetail: false,
                JobOrderCustomsDetailError: action.payload,
            };
        //detail job order customs//

        //list job order custom house//
        case 'FIND_JOBORDER_CUSTOMS_HOUSE_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderCustomsHouseList: true,
                JobOrderCustomsHouseList: "",
                JobOrderCustomsHouseListError: '',
            };
        case 'FIND_JOBORDER_CUSTOMS_HOUSE_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderCustomsHouseList: false,
                JobOrderCustomsHouseList: action.payload,
            };
        case 'FIND_JOBORDER_CUSTOMS_HOUSE_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderCustomsHouseList: false,
                JobOrderCustomsHouseListError: action.payload,
            };
        //list job order custom house//

        //list job order exim scheme//
        case 'FIND_JOBORDER_EXIM_SCHEME_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderEximSchemeList: true,
                JobOrderEximSchemeList: "",
                JobOrderEximSchemeListError: '',
            };
        case 'FIND_JOBORDER_EXIM_SCHEME_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderEximSchemeList: false,
                JobOrderEximSchemeList: action.payload,
            };
        case 'FIND_JOBORDER_EXIM_SCHEME_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderEximSchemeList: false,
                JobOrderEximSchemeListError: action.payload,
            };
        //list job order exim scheme//

        //list job order port//
        case 'FIND_JOBORDER_PORT_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderPortList: true,
                JobOrderPortList: "",
                JobOrderPortListError: '',
            };
        case 'FIND_JOBORDER_PORT_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderPortList: false,
                JobOrderPortList: action.payload,
            };
        case 'FIND_JOBORDER_PORT_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderPortList: false,
                JobOrderPortListError: action.payload,
            };
        //list job order port//

        //list job order airport//
        case 'FIND_JOBORDER_AIRPORT_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderAirportList: true,
                JobOrderAirportList: "",
                JobOrderAirportListError: '',
            };
        case 'FIND_JOBORDER_AIRPORT_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderAirportList: false,
                JobOrderAirportList: action.payload,
            };
        case 'FIND_JOBORDER_AIRPORT_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderAirportList: false,
                JobOrderAirportListError: action.payload,
            };
        //list job order airport//

        //list job order seaport//
        case 'FIND_JOBORDER_SEAPORT_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderSeaportList: true,
                JobOrderSeaportList: "",
                JobOrderSeaportListError: '',
            };
        case 'FIND_JOBORDER_SEAPORT_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderSeaportList: false,
                JobOrderSeaportList: action.payload,
            };
        case 'FIND_JOBORDER_SEAPORT_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderSeaportList: false,
                JobOrderSeaportListError: action.payload,
            };
        //list job order seaport//

        //list job order airline//
        case 'FIND_JOBORDER_AIRLINE_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderAirlineList: true,
                JobOrderAirlineList: "",
                JobOrderAirlineListError: '',
            };
        case 'FIND_JOBORDER_AIRLINE_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderAirlineList: false,
                JobOrderAirlineList: action.payload,
            };
        case 'FIND_JOBORDER_AIRLINE_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderAirlineList: false,
                JobOrderAirlineListError: action.payload,
            };
        //list job order airline//

        //list job order shipline//
        case 'FIND_JOBORDER_SHIPLINE_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderShiplineList: true,
                JobOrderShiplineList: "",
                JobOrderShiplineListError: '',
            };
        case 'FIND_JOBORDER_SHIPLINE_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderShiplineList: false,
                JobOrderShiplineList: action.payload,
            };
        case 'FIND_JOBORDER_SHIPLINE_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderShiplineList: false,
                JobOrderShiplineListError: action.payload,
            };
        //list job order shipline//

        //detail job order freight//
        case 'FIND_JOBORDER_FREIGHT_DETAIL_REQUEST':
            return {
                ...state,
                loadingJobOrderFreightDetail: true,
                JobOrderFreightDetail: "",
                JobOrderFreightDetailError: '',
            };
        case 'FIND_JOBORDER_FREIGHT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingJobOrderFreightDetail: false,
                JobOrderFreightDetail: action.payload,
            };
        case 'FIND_JOBORDER_FREIGHT_DETAIL_FAILURE':
            return {
                ...state,
                loadingJobOrderFreightDetail: false,
                JobOrderFreightDetailError: action.payload,
            };
        //detail job order freight//

        //detail job order incoterms//
        case 'FIND_JOBORDER_INCOTERM_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderIncotermList: true,
                JobOrderIncotermList: "",
                JobOrderIncotermListError: '',
            };
        case 'FIND_JOBORDER_INCOTERM_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderIncotermList: false,
                JobOrderIncotermList: action.payload,
            };
        case 'FIND_JOBORDER_INCOTERM_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderIncotermList: false,
                JobOrderIncotermListError: action.payload,
            };
        //detail job order incoterms//

        //list job order currency//
        case 'FIND_JOBORDER_CURRENCY_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderCurrencyList: true,
                JobOrderCurrencyList: "",
                JobOrderCurrencyListError: '',
            };
        case 'FIND_JOBORDER_CURRENCY_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderCurrencyList: false,
                JobOrderCurrencyList: action.payload,
            };
        case 'FIND_JOBORDER_CURRENCY_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderCurrencyList: false,
                JobOrderCurrencyListError: action.payload,
            };
        //detail job order currency//

        //Cargo Tab//
        case 'FIND_JOBORDER_CARGO_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderCargoList: true,
                JobOrderCargoList: "",
                JobOrderCargoListError: '',
            };
        case 'FIND_JOBORDER_CARGO_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderCargoList: false,
                JobOrderCargoList: action.payload,
            };
        case 'FIND_JOBORDER_CARGO_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderCargoList: false,
                JobOrderCargoListError: action.payload,
            };
        //Cargo tab //
        //lsit job order cfs//
        case 'FIND_JOBORDER_CFS_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderCFSList: true,
                JobOrderCFSList: [],
                JobOrderCFSListError: '',
            };
        case 'FIND_JOBORDER_CFS_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderCFSList: false,
                JobOrderCFSList: action.payload,
            };
        case 'FIND_JOBORDER_CFS_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderCFSList: false,
                JobOrderCFSListError: action.payload,
            };
        //list job order cfs//

        //job order transport pickup branch list//
        case 'FIND_JOBORDER_TRANSPORT_PICKUP_BRANCH_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderTransportPickupBranchList: true,
                JobOrderTransportPickupBranchList: [],
                JobOrderTransportPickupBranchListError: '',
            };
        case 'FIND_JOBORDER_TRANSPORT_PICKUP_BRANCH_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderTransportPickupBranchList: false,
                JobOrderTransportPickupBranchList: action.payload,
            };
        case 'FIND_JOBORDER_TRANSPORT_PICKUP_BRANCH_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderTransportPickupBranchList: false,
                JobOrderTransportPickupBranchListError: action.payload,
            };
        //job order transport pickup branch list//

        //job order transport deliver branch list//
        case 'FIND_JOBORDER_TRANSPORT_DELIVER_BRANCH_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderTransportDeliverBranchList: true,
                JobOrderTransportDeliverBranchList: [],
                JobOrderTransportDeliverBranchListError: '',
            };
        case 'FIND_JOBORDER_TRANSPORT_DELIVER_BRANCH_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderTransportDeliverBranchList: false,
                JobOrderTransportDeliverBranchList: action.payload,
            };
        case 'FIND_JOBORDER_TRANSPORT_DELIVER_BRANCH_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderTransportDeliverBranchList: false,
                JobOrderTransportDeliverBranchListError: action.payload,
            };
        //job order transport deliver branch list//

        //job order transport transporter branch list//
        case 'FIND_JOBORDER_TRANSPORT_TRANSPORTER_BRANCH_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderTransportTransporterBranchList: true,
                JobOrderTransportTransporterBranchList: [],
                JobOrderTransportTransporterBranchListError: '',
            };
        case 'FIND_JOBORDER_TRANSPORT_TRANSPORTER_BRANCH_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderTransportTransporterBranchList: false,
                JobOrderTransportTransporterBranchList: action.payload,
            };
        case 'FIND_JOBORDER_TRANSPORT_TRANSPORTER_BRANCH_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderTransportTransporterBranchList: false,
                JobOrderTransportTransporterBranchListError: action.payload,
            };
        //job order transport transporter branch list//

        //job order transport list//
        case 'FIND_JOBORDER_TRANSPORT_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderTransportList: true,
                JobOrderTransportList: [],
                JobOrderTransportListError: '',
            };
        case 'FIND_JOBORDER_TRANSPORT_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderTransportList: false,
                JobOrderTransportList: action.payload,
            };
        case 'FIND_JOBORDER_TRANSPORT_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderTransportList: false,
                JobOrderTransportListError: action.payload,
            };
        //job order transport list//

        //job order transport detail//
        case 'FIND_JOBORDER_TRANSPORT_DETAIL_REQUEST':
            return {
                ...state,
                loadingJobOrderTransportDetail: true,
                JobOrderTransportDetail: [],
                JobOrderTransportDetailError: '',
            };
        case 'FIND_JOBORDER_TRANSPORT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingJobOrderTransportDetail: false,
                JobOrderTransportDetail: action.payload,
            };
        case 'FIND_JOBORDER_TRANSPORT_DETAIL_FAILURE':
            return {
                ...state,
                loadingJobOrderTransportDetail: false,
                JobOrderTransportDetailError: action.payload,
            };
        //job order transport detail//

        //job order commodity list//
        case 'FIND_JOBORDER_COMMODITY_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderCommodityList: true,
                JobOrderCommodityList: [],
                JobOrderCommodityListError: '',
            };
        case 'FIND_JOBORDER_COMMODITY_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderCommodityList: false,
                JobOrderCommodityList: action.payload,
            };
        case 'FIND_JOBORDER_COMMODITY_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderCommodityList: false,
                JobOrderCommodityListError: action.payload,
            };
        //job order commodity list//

        //job order commodity list//
        case 'FIND_JOBORDER_CARGO_DETAIL_REQUEST':
            return {
                ...state,
                loadingJobOrderCargoDetail: true,
                JobOrderCargoDetail: [],
                JobOrderCargoDetailError: '',
            };
        case 'FIND_JOBORDER_CARGO_DETAIL_SUCCESS':
            return {
                ...state,
                loadingJobOrderCargoDetail: false,
                JobOrderCargoDetail: action.payload,
            };
        case 'FIND_JOBORDER_CARGO_DETAIL_FAILURE':
            return {
                ...state,
                loadingJobOrderCargoDetail: false,
                JobOrderCargoDetailError: action.payload,
            };
        //job order commodity list//

        //job order approved customer list//
        case 'FIND_JOB_ORDER_APPROVED_CUSTOMERS_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderApprovedCustomerList: true,
                JobOrderApprovedCustomerList: [],
                JobOrderApprovedCustomerListError: '',
            };
        case 'FIND_JOB_ORDER_APPROVED_CUSTOMERS_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderApprovedCustomerList: false,
                JobOrderApprovedCustomerList: action.payload,
            };
        case 'FIND_JOB_ORDER_APPROVED_CUSTOMERS_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderApprovedCustomerList: false,
                JobOrderApprovedCustomerListError: action.payload,
            };
        //job order approved customer list//

        //job order company branch list//
        case 'FIND_JOB_ORDER_COMPANY_BRANCH_LIST_REQUEST':
            return {
                ...state,
                loadingJobOrderCompanyBranchList: true,
                JobOrderCompanyBranchList: [],
                JobOrderCompanyBranchListError: '',
            };
        case 'FIND_JOB_ORDER_COMPANY_BRANCH_LIST_SUCCESS':
            return {
                ...state,
                loadingJobOrderCompanyBranchList: false,
                JobOrderCompanyBranchList: action.payload,
            };
        case 'FIND_JOB_ORDER_COMPANY_BRANCH_LIST_FAILURE':
            return {
                ...state,
                loadingJobOrderCompanyBranchList: false,
                JobOrderCompanyBranchListError: action.payload,
            };
        //job order company branch list//

        //job order ff details by job order//
        case 'FIND_FF_DETAILS_BY_JOBORDER_REQUEST':
            return {
                ...state,
                loadingJobOrderFFDetails: true,
                JobOrderFFDetails: null,
                JobOrderFFDetailsError: '',
            };
        case 'FIND_FF_DETAILS_BY_JOBORDER_SUCCESS':
            return {
                ...state,
                loadingJobOrderFFDetails: false,
                JobOrderFFDetails: action.payload,
            };
        case 'FIND_FF_DETAILS_BY_JOBORDER_FAILURE':
            return {
                ...state,
                loadingJobOrderFFDetails: false,
                JobOrderFFDetailsError: action.payload,
            };
        //job order ff details by job order//

        default:
            return state;
    }
}

export default JoborderReducer;